import React, { useState, DetailedHTMLProps, InputHTMLAttributes } from 'react'
import { noop } from 'lodash'

import { classNames } from 'utils/dom'

import { root, checkbox } from './index.module.scss'

interface CheckboxProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  onFocus?: (e: React.FocusEvent<HTMLSpanElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLSpanElement>) => void
}

const Checkbox = ({
  checked,
  className,
  onFocus = noop,
  onBlur = noop,
  ...props
}: CheckboxProps) => {
  const [focused, setFocused] = useState(false)
  return (
    <span
      className={classNames([root, className])}
      data-checked={checked}
      data-focused={focused}
      onFocus={(e) => {
        setFocused(true)
        onFocus(e)
      }}
      onBlur={(e) => {
        setFocused(false)
        onBlur(e)
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        className={checkbox}
        {...props}
      />
    </span>
  )
}

export default Checkbox
